const config = {
  api: {
    tokenizeURI: process.env.NEXT_PUBLIC_REACT_APP_TDS_TOKENIZER
  },
  currency: process.env.NEXT_PUBLIC_REACT_APP_CURRENCY,
  enableCredits: process.env.NEXT_PUBLIC_REACT_APP_ENABLE_CREDITS === 'true',
  enableLoyalty: process.env.NEXT_PUBLIC_REACT_APP_ENABLE_LOYALTY === 'true',
  enableProtectGroup: process.env.NEXT_PUBLIC_REACT_APP_ENABLE_PROTECT_GROUP === 'true',
  ipTraceURLs: {
    CA: 'https://www.cloudflare.com/cdn-cgi/trace',
    US: 'https://www.cloudflare.com/cdn-cgi/trace'
  },
  kount: {
    kountMerchId: process.env.NEXT_PUBLIC_REACT_APP_KOUNT_MERCHANT_ID
  },
  PET_ADDON: 'Pet Fee',
  PROTECTION_ADDON: 'Trip Protection',
  protectGroupOptions: {
    currencyCode: process.env.NEXT_PUBLIC_REACT_APP_CURRENCY || '',
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 'prod' : 'test',
    languageCode: 'en',
    useSaleAction: true,
    vendorCode: process.env.NEXT_PUBLIC_REACT_APP_PROTECT_GROUP_VENDOR_CODE || ''
  },
  PUBLIC_KEY:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAry0oVf9w//tPbg1cZJOycsVgULdGhkD5hSLAjY2z3mKv2Fv8bexoiMAfklS01bOAehb4LdpG8HNeVcl92LAY+5+s81RRn7MK2KEk/509wBap8sdXouiXvk/z6xBqzLwxPCHjoFM/0i0qpEfeeF6aQvThqzrvAjSoi+CYZ8j/1nK8tVG08QcrE7C0/EB4OVDmtJAIRE9vgMcrMnRB+hZ2xOzm7YxH/oam2rsO3gUkAWan2Z5lB2Hjze1IgLOMsl8ZEuJFey7INdB+VPlyTpMRxwP5jmpye6R8rh5dRlL3LS+csahr/Oh2FPsWZ/nQONNtmSlOuYFtoEskQGKfyfVsDQIDAQAB',
  webhookUrl: 'https://webhooks.trailways.com'
};

export default config;
